import { Icon, type IconProps } from './Icon';

/**
 * Landscape glyph used as a fallback when an image is missing.
 * Mountain + sun + frame — recognisable at any size from 16px upward.
 */
export function PicturePlaceholder(props: IconProps) {
  return (
    <Icon strokeWidth={1.5} {...props}>
      <rect x="3" y="3" width="18" height="18" rx="3" />
      <circle cx="8.5" cy="9" r="1.5" fill="currentColor" stroke="none" />
      <path d="m21 15-4.5-4.5L7 21" />
    </Icon>
  );
}
